// extracted by mini-css-extract-plugin
module.exports = {"card-container":"dash_card-container__aRmBl","number":"dash_number__Usv5l"};